import { render } from "./NegotiationsModal.vue?vue&type=template&id=8036e678"
import script from "./NegotiationsModal.vue?vue&type=script&lang=js"
export * from "./NegotiationsModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__